import { useState } from "react";
import AppLayout from "@/components/feature/AppLayout";
import Breadcrumb from "@/components/feature/Breadcrumb";
import SectionHeader from "@/components/feature/SectionHeader";
import NovelCard from "@/components/feature/NovelCard";
import useSeo from "@/hooks/useSeo";
import { novels } from "@/mocks/narutoContent";

const filters = ["全部", "成长向", "悲情向", "宿命向", "治愈向", "群像", "情感向"];

export default function Novels() {
  const [active, setActive] = useState("全部");

  const list = active === "全部" ? novels : novels.filter((n) => n.tag.includes(active));

  useSeo({
    title: "火影忍者同人小说 - 同人文长篇连载 | 影页社",
    description:
      "影页社火影忍者同人小说栏目，收录成长、悲情、宿命、治愈等多题材同人文与长篇连载，围绕角色、羁绊与忍道展开走心叙事，供同好免费阅读与追更。",
    keywords: "火影忍者同人小说,火影忍者同人文,火影忍者同人长篇,火影同人连载",
    canonical: "https://wn-baidu.cn/xiaoshuo",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "CollectionPage",
        name: "影页社 · 火影忍者同人小说",
        description: "火影忍者同人小说与同人文长篇连载列表",
        url: "https://wn-baidu.cn/xiaoshuo",
      },
      {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "首页", item: "https://wn-baidu.cn/" },
          { "@type": "ListItem", position: 2, name: "同人小说", item: "https://wn-baidu.cn/xiaoshuo" },
        ],
      },
    ],
  });

  return (
    <AppLayout>
      <div className="pt-20">
        <Breadcrumb items={[{ name: "同人小说" }]} />

        <header className="mx-auto w-full max-w-7xl px-4 md:px-6 pt-6 pb-4">
          <h1 className="font-display text-3xl md:text-4xl text-foreground-950">火影忍者同人小说</h1>
          <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600">
            从吊车尾到火影，从晓之暗夜到木叶日常。这里收录多题材的同人文与长篇连载，用文字重新书写关于忍道、羁绊与归途的故事。
          </p>
        </header>

        {/* 筛选 */}
        <div className="mx-auto w-full max-w-7xl px-4 md:px-6 py-4">
          <div className="inline-flex flex-wrap items-center gap-2 rounded-full border border-background-200 bg-background-100 p-1">
            {filters.map((f) => (
              <button
                key={f}
                type="button"
                onClick={() => setActive(f)}
                className={`rounded-full px-4 py-2 font-label text-sm whitespace-nowrap transition-colors ${
                  active === f ? "bg-primary-500 text-background-50" : "text-foreground-700 hover:bg-secondary-100"
                }`}
              >
                {f}
              </button>
            ))}
          </div>
        </div>

        {/* 列表 */}
        <div className="mx-auto w-full max-w-7xl px-4 md:px-6 py-6 pb-16">
          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {list.map((n) => (
              <NovelCard key={n.id} novel={n} />
            ))}
          </div>
          {list.length === 0 && (
            <p className="py-16 text-center text-sm text-foreground-500">该分类下暂无小说，敬请期待。</p>
          )}
        </div>
      </div>
    </AppLayout>
  );
}